// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"190":"d54f1776","416":"2ddd743a","453":"cc2a868f","538":"087f0f19","566":"151391a0","882":"5646959a"}[chunkId] + ".chunk.js";
};